import { render, staticRenderFns } from "./ThgChargingStationHelpDialog.vue?vue&type=template&id=89a4158e"
import script from "./ThgChargingStationHelpDialog.vue?vue&type=script&lang=ts"
export * from "./ThgChargingStationHelpDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports